import * as constants from './constants';
import R from 'ramda';

const initialState = {
  globalFilters: {},
  items: [],
};
export function contractingDashboard(state = initialState, { type, user, payload, args = [{}] }) {
  switch (type) {
    case constants.INIT_DASHBOARD:
      return payload.initialState;
    case `${constants.LOAD_FOLDERS}_SUCCESS`:
      return { ...state,
        globalFilters: {
          ...state.globalFilters,
          folder: {
            ...state.globalFilters.folder,
            list: payload.folders.map(str => ({ title: str, value: str })),
          },
        },
      };
    case constants.UPDATE_GLOBAL_FILTER:
      return { ...state,
        globalFilters: {
          ...state.globalFilters,
          [payload.filterItem]: {
            ...state.globalFilters[payload.filterItem],
            selectedValue: state.globalFilters[payload.filterItem].type === 'checkbox' ? !(payload.value === 'true') : payload.value,
          },
        },
      };
    case constants.UPDATE_GLOBAL_LIST_FILTER:
      const updatedList = state.globalFilters[payload.filterKey].list.map((obj, i) => {
        if (i === payload.listIndex) return R.assoc('checked', payload.checked, obj);
        return obj;
      });
      return {
        ...state,
        globalFilters: {
          ...state.globalFilters,
          [payload.filterKey]: {
            ...state.globalFilters[payload.filterKey],
            list: updatedList,
            selectedValue: updatedList.some(obj => obj.checked),
          },
        }
      };
    case constants.CLEAR_GLOBAL_LIST_FILTER:
      return {
        ...state,
        globalFilters: {
          ...state.globalFilters,
          [payload.filterKey]: {
            ...state.globalFilters[payload.filterKey],
            selectedValue: null,
            list: state.globalFilters[payload.filterKey].list.map((obj, i) => {
              return R.assoc('checked', false, obj);
            }),
          },
        }
      };
    case `${constants.UPDATE_WIDGET_DATA}_STARTED`:
      return {
        ...state,
        items: state.items.map(item => {
          if (item.id === args[0].widgetId) {
            return {
              ...item,
              error: false,
              isLoading: true,
            };
          }
          return item;
        }),
      };
    case `${constants.UPDATE_WIDGET_DATA}_ERROR`:
      return {
        ...state,
        items: state.items.map(item => {
          if (item.id === args[0].widgetId) {
            return {
              ...item,
              error: true,
              isLoading: false,
              lastSync: null,
            };
          }
          return item;
        }),
      };
    case constants.RESET_GLOBAL_DASHBOARD_FILTER:
      return Object.assign({}, state, {
        globalFilters: Object.entries(state.globalFilters)
        .map(([key, value]) => ({
          [key]: Object.assign(
            {},
            value,
            value.type === 'list'
              ? {
                list: value.list.map(obj => R.assoc('checked', false, obj)),
                selectedValue: null
              }
              : { selectedValue: null }
            )
        }))
        .reduce((obj, item) => Object.assign({}, { ...item }, obj)),
      });
    case `${constants.UPDATE_WIDGET_DATA}_SUCCESS`:
      return Object.assign({}, state, {
        items: state.items.map(item => {
          if (item.id === args[0].widgetId) {
            if (item.chart === 'Callout') {
              return {
                ...item,
                isLoading: false,
                error: false,
                data: payload.data.filter(d => d.label === item.name).reduce((a, b) => b.value, 0),
              };
            }
            return {
              ...item,
              ...payload,
              isLoading: false,
              error: false,
              lastSync: Math.round(new Date().getTime() / 1000),
            };
          }
          return item;
        }),
      });
    case constants.UPDATE_WIDGET_FILTER:
      return {
        ...state,
        ...{
          items: state.items.map(item => {
            if (item.id === payload.id) {
              const filterBy = payload.filterBy;
              const filtersCopy = { ...item.filters };
              filtersCopy[filterBy] = {
                ...filtersCopy[filterBy],
                ...payload.filterObjSelected,
              };
              return {
                ...item,
                filters: filtersCopy,
              };
            }
            return item;
          }),
        }
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/contracting-dashboard/__storeFiles__/reducer.js